import { useContext, useEffect, useState } from "react";
import { haveValue } from "../helper/common";
import TenantContext from "../context/tenant/TenantContext";
import AuthContext from "../context/auth/AuthContext";
import CloseIcon from "../assets/img/closeIcon.svg";
import UserIcon from "../assets/img/user-icon.svg";
import SkorDefaultLoader from "../assets/img/skorDefaultLoader.gif";
import useTranslator from "../hooks/useTranslator";
import { Link } from "react-router-dom";
import Cancelimg from "../assets/img/cancel-01.svg";
import ConsentStepModal from "../pages/onboarding/ConsentStepModal";

const ShareProfileModal = ({
  isOpen,
  onClose,
  setShareQrModal,
  loadLandlords,
  setAllLandlords,
  landlordsOrig,
  setAllLandlordsOrig,
  searchText,
  setSearchText,
  loading1,
  landlords,
  setShowRemove,
  shareProfileFun,
  setRemoveLandlordId,
  processingLandlordId,
}) => {
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const { user, loadUserTenant } = authContext;
  const tenantContext = useContext(TenantContext);
  const { fullProfileShared, loadSharedProfiles } = tenantContext;
  const queryParam = new URLSearchParams(window.location.search);
  const [filteredShortlisted, setFilteredShortlisted] = useState([]);
  const [showConsent, setShowConsent] = useState(false);
  const [selectedLandlord, setSelectedLandlord] = useState({});

  useEffect(() => {
    const userid = localStorage.getItem("saveduserid");
    if (user && user?._id) {
      loadSharedProfiles(user?._id, "full");
    } else if (haveValue(userid)) {
      loadSharedProfiles(userid, "full");
    }
  }, []);

  useEffect(() => {
    setFilteredShortlisted(fullProfileShared);
    setAllLandlords((prev) => [...prev]);
    setAllLandlordsOrig((prev) => [...prev]);
  }, [fullProfileShared]);

  const filterlandlord = (searchText) => {
    const temp = [...landlordsOrig];
    const filtered = temp.filter((val) =>
      `${val?.fname_companyName} ${val?.lname}`
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );
    setAllLandlords(filtered);
  };

  const isPropertyLinked = (landlordid) => {
    for (const profileShared of fullProfileShared) {
      if (
        profileShared.landlordid === landlordid &&
        haveValue(profileShared?.propertyid)
      ) {
        return profileShared;
      }
    }
    return null;
  };

  const isProfileShared = (landlordid) => {
    if (fullProfileShared !== null) {
      for (const profileShared of fullProfileShared) {
        if (profileShared.landlordid === landlordid) {
          return true;
        }
      }
      return false;
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      const effect_func = async () => {
        await loadLandlords();

        if (haveValue(queryParam.get("filter"))) {
          const name = queryParam.get("filter");
          const e = { target: { value: name } };
          setSearchText(name);
          filterlandlord(name);
        }
      };
      if ((searchText ?? "").length > 0) {
        effect_func();
      }
    }, 250);

    return () => clearTimeout(handler);
  }, [searchText]);

  return (
    isOpen && (
      <div className="wrapper-modal" onClick={onClose}>
        <div
          className={`doc-history-popup total-salary-modal share-profile-modal ${
            isOpen ? "open" : ""
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <span className="drawerIcon" onClick={onClose} />
          <div>
            <div className="doc-history-header">
              <div className="d-flex align-items-center custom-gap-2">
                <img
                  src={CloseIcon}
                  alt=""
                  className="doc-history-close-btn"
                  onClick={onClose}
                />
                <h4 className="custom-modal-heading">
                  {_t("shareYourProfile")}
                </h4>
              </div>
              <button
                className="shareYourQrButton"
                onClick={() => {
                  setShareQrModal(true);
                  onClose();
                }}
              >
                <img src="/images/scan-icon.svg" className="scanIcon" />
                {_t("shareYourQr")}
                <img
                  src="/images/arrow-right-white.svg"
                  className="arrowRightIcon"
                />
              </button>
            </div>
          </div>
          <div className="listWrapper">
            <div className="tabs-box-pattern">
              <div className="tabs-item d-block">
                {/* <div className="profile-page marless tab-profile-search-header">
                  <div className="Search-bar searchbar_cls">
                    <div className="search_bar_edit">
                      <a href="#">
                        <img src={"/images/search-icon-grey.svg"} alt="" />
                      </a>
                      <input
                        type="text"
                        className="custom-input mb-0 input01"
                        onChange={(e) => {
                          setSearchText(e.target.value);
                        }}
                        value={searchText}
                        placeholder={_t("searchAgentLandlord")}
                      />
                      {haveValue(searchText) ? (
                        <img
                          src={Cancelimg}
                          alt="icon"
                          onClick={() => {
                            setSearchText("");
                          }}
                          className="canceicon topRightIcon searchCrossIcon"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div> */}

                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    {loading1 && (
                      <div className="text-center my-4">
                        <img
                          src={SkorDefaultLoader}
                          className="defaultSkorLoader"
                          alt="Example"
                        />
                      </div>
                    )}
                    <div className="edit-profile">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div className="edit-profile">
                          <div className="Shortlisted-Properties"></div>
                          <div className="shareProfileHeader d-flex align-items-center custom-gap-2 justify-content-between">
                            <h4 className="sharedWithText">
                              {haveValue(searchText)
                                ? _t("searchResult")
                                : _t("sharedWith")}
                            </h4>
                          </div>
                          <div className="Notifications-row">
                            {Array.isArray(landlords) &&
                            haveValue(searchText) &&
                            landlords.length > 0 ? (
                              landlords?.map((landlord) => {
                                let property_linked = isPropertyLinked(
                                  landlord?._id
                                );
                                return (
                                  <>
                                    {(haveValue(searchText) ||
                                      isProfileShared(landlord?._id)) && (
                                      <div
                                        className="Notifications-wapper opacity-wapper px-0 tt"
                                        key={landlord?._id}
                                      >
                                        <div className="mobile-profile-info-box">
                                          <div className="userImageWrapper">
                                            <img src={UserIcon} />
                                          </div>
                                          <div className="userDetails">
                                            <h4>
                                              {landlord?.fname_companyName}{" "}
                                              {landlord?.lname}
                                            </h4>
                                            {haveValue(property_linked) &&
                                              (property_linked?.propertyid
                                                ?.length > 0 ? (
                                                <p className="d-flex gap-2 locationText">
                                                  {property_linked?.propertyid
                                                    ?.map(
                                                      (props) =>
                                                        `${props?.street} - ${
                                                          Number.isNaN(
                                                            parseInt(
                                                              props?.street_number,
                                                              10
                                                            )
                                                          )
                                                            ? "N/A"
                                                            : String(
                                                                parseInt(
                                                                  props?.street_number,
                                                                  10
                                                                )
                                                              )
                                                        }, ${
                                                          props.floor_number
                                                        }-${props.flat_number}`
                                                    )
                                                    .join(" / ")}
                                                </p>
                                              ) : (
                                                <p className="d-flex gap-2 noPropertyLinked">
                                                  {_t("noPropertyLinked")}
                                                </p>
                                              ))}
                                          </div>
                                        </div>

                                        <div className="share-it">
                                          {isProfileShared(landlord?._id) ? (
                                            <Link
                                              onClick={() => {
                                                onClose();
                                                setShowRemove(true);
                                                setRemoveLandlordId(
                                                  landlord?._id
                                                );
                                              }}
                                              className="share-btn"
                                            >
                                              {_t("unshare")}
                                            </Link>
                                          ) : (
                                            <Link
                                              onClick={() => {
                                                if (
                                                  landlord._id !==
                                                  processingLandlordId
                                                ) {
                                                  if (
                                                    (landlord?.insurance_service_status &&
                                                      (!haveValue(
                                                        user?.consents
                                                          ?.gdpr_consent
                                                      ) ||
                                                        !haveValue(
                                                          user?.consents
                                                            ?.skor_consent
                                                        ))) ||
                                                    (landlord?.affidavit_activated &&
                                                      !haveValue(
                                                        user?.consents
                                                          ?.declaration_consent
                                                      ))
                                                  ) {
                                                    setShowConsent(true);
                                                    setSelectedLandlord(
                                                      landlord
                                                    );
                                                  } else {
                                                    shareProfileFun(
                                                      user._id,
                                                      landlord._id,
                                                      "full",
                                                      landlord,
                                                      true
                                                    );
                                                  }
                                                }
                                              }}
                                              style={{
                                                opacity:
                                                  landlord._id ===
                                                  processingLandlordId
                                                    ? 0.5
                                                    : 1,
                                                pointerEvents:
                                                  landlord._id ===
                                                  processingLandlordId
                                                    ? "none"
                                                    : "auto",
                                              }}
                                            >
                                              <img src="/images/share-icon.svg" />
                                              {landlord._id ===
                                              processingLandlordId
                                                ? _t("sharing")
                                                : _t("share")}
                                            </Link>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </>
                                );
                              })
                            ) : haveValue(searchText) && !loading1 ? (
                              <p className="notSharedText text-center">
                                {_t("noDataFound")}
                              </p>
                            ) : null}
                            {Array.isArray(filteredShortlisted) &&
                            !haveValue(searchText) &&
                            filteredShortlisted.length > 0 ? (
                              filteredShortlisted?.map((landlord) => {
                                let property_linked = isPropertyLinked(
                                  landlord?.landlordid
                                );
                                return (
                                  <>
                                    {
                                      <div
                                        className="Notifications-wapper opacity-wapper px-0 tt"
                                        key={landlord?.landlordid}
                                      >
                                        <div className="mobile-profile-info-box">
                                          <div className="userImageWrapper">
                                            <img src={UserIcon} />
                                          </div>
                                          <div className="userDetails">
                                            <h4>
                                              {landlord?.landlord_fname}{" "}
                                              {landlord?.landlord_lname}
                                            </h4>
                                            {haveValue(property_linked) &&
                                              (property_linked?.propertyid
                                                ?.length > 0 ? (
                                                <p className="d-flex gap-2 locationText">
                                                  {property_linked?.propertyid
                                                    ?.map(
                                                      (props) =>
                                                        `${props?.street} - ${
                                                          Number.isNaN(
                                                            parseInt(
                                                              props?.street_number,
                                                              10
                                                            )
                                                          )
                                                            ? "N/A"
                                                            : String(
                                                                parseInt(
                                                                  props?.street_number,
                                                                  10
                                                                )
                                                              )
                                                        }, ${
                                                          props.floor_number
                                                        }-${props.flat_number}`
                                                    )
                                                    .join(" / ")}
                                                </p>
                                              ) : (
                                                <p className="d-flex gap-2 noPropertyLinked">
                                                  {_t("noPropertyLinked")}
                                                </p>
                                              ))}
                                          </div>
                                        </div>

                                        <div className="share-it">
                                          <Link
                                            onClick={() => {
                                              onClose();
                                              setShowRemove(true);
                                              setRemoveLandlordId(
                                                landlord?.landlordid
                                              );
                                            }}
                                            className="share-btn"
                                          >
                                            {_t("unshare")}
                                          </Link>
                                        </div>
                                      </div>
                                    }
                                  </>
                                );
                              })
                            ) : !haveValue(searchText) ? (
                              <p className="notSharedText text-center">
                                {_t(
                                  "youHaventSharedYourProfileWithAnyLandlordOrAgentYet"
                                )}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showConsent && (
            <ConsentStepModal
              user={user}
              isPopup={true}
              onClose={() => setShowConsent(false)}
              loadSharedProfiles={loadSharedProfiles}
              loadUserTenant={loadUserTenant}
              selectedLandlord={selectedLandlord}
              shareProfileWithLandlord={() =>
                shareProfileFun(
                  user._id,
                  selectedLandlord._id,
                  "full",
                  selectedLandlord,
                  true
                )
              }
            />
          )}
        </div>
      </div>
    )
  );
};

export default ShareProfileModal;
